// extracted by mini-css-extract-plugin
export var documentation = "_j7-1";
export var menu = "_j7-0";